(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("deleteAccount", {
        templateUrl: "app/accounts/delete/deleteAccount.component.html",
        bindings: {
            modalInstance: "<",
            resolve: "<",
        },
        controller: [DeleteAccountCtrl],
        controllerAs: "vm"
    });
    function DeleteAccountCtrl() {
        var vm = this;
        vm.delete = deleteAccount;
        //EXAMPLE Pass input data to modal component (part 2)
        vm.$onInit = function () {
            vm.account = vm.resolve.account;
        };
        ///////////////////////////////////
        function deleteAccount() {
            if (vm.form.$valid) {
                vm.modalInstance.close(vm.model);
            }
            else {
                vm.showErrors = true;
            }
        }
    }
}());
